<script setup lang="ts">
import DangerDialog from '@/components/dialog/DangerDialog.vue';

const props = defineProps<{
  action: App.Sms.Data.AutomatedCampaigns.AutomatedActionData;
}>();

const isDeleteDialogOpen = ref(false);

const deleteForm = useForm({
  fields: {},
  method: 'delete',
  url: route('sms.actions.delete', { action: props.action })
});

function openDialog() {
  isDeleteDialogOpen.value = true;
}

function handleDeleteMessage() {
  deleteForm.submit();
}
</script>

<template>
  <slot name="default" v-bind="{ openDialog }" />

  <DangerDialog
    title="Delete action"
    message="Are you sure you want to delete this action? You will not be able to revert this action."
    confirmButtonLabel="Delete action"
    :isOpen="isDeleteDialogOpen"
    :isLoading="deleteForm.processing"
    @onCancel="isDeleteDialogOpen = false"
    @onClose="isDeleteDialogOpen = false"
    @onConfirm="handleDeleteMessage"
  />
</template>
